import {IdName} from '@domain/id-name';
import {AssertionUtils, Color} from '@vdw/angular-component-library';
import {RejectType} from './reject-type.enum';

export class RejectReason {
  private _id: number;
  private _name: string;
  private _color: Color;
  private _rejectType: RejectType;
  private _code: number;
  private _displayOrder: number;
  private _machineTypes: IdName[];
  private _group: IdName;
  private _description: string;

  public constructor(id: number, name: string, color: Color, rejectType: RejectType, code: number, displayOrder: number, machineTypes: IdName[], group: IdName, description: string) {
    this._id = id;
    this._name = name;
    this._color = color;
    this._rejectType = rejectType;
    this._code = code;
    this._displayOrder = displayOrder;
    this._machineTypes = machineTypes;
    this._group = group;
    this._description = description;
  }

  public get id(): number {
    return this._id;
  }

  public set id(value: number) {
    this._id = value;
  }

  public get name(): string {
    return this._name;
  }

  public set name(value: string) {
    this._name = value;
  }

  public get color(): Color {
    return this._color;
  }

  public set color(value: Color) {
    this._color = value;
  }

  public get rejectType(): RejectType {
    return this._rejectType;
  }

  public set rejectType(value: RejectType) {
    this._rejectType = value;
  }

  public get code(): number {
    return this._code;
  }

  public set code(value: number) {
    this._code = value;
  }

  public get displayOrder(): number {
    return this._displayOrder;
  }

  public set displayOrder(value: number) {
    this._displayOrder = value;
  }

  public get machineTypes(): IdName[] {
    return this._machineTypes;
  }

  public set machineTypes(value: IdName[]) {
    this._machineTypes = value;
  }

  public get group(): IdName {
    return this._group;
  }

  public set group(value: IdName) {
    this._group = value;
  }

  public get description(): string {
    return this._description;
  }

  public set description(value: string) {
    this._description = value;
  }

  public static fromJSON(rejectReasonJSON: any): RejectReason {
    return new RejectReason(
      rejectReasonJSON.id,
      rejectReasonJSON.name,
      new Color(null, null, {red: rejectReasonJSON.rgb.red, green: rejectReasonJSON.rgb.green, blue: rejectReasonJSON.rgb.blue}, false),
      rejectReasonJSON.rejectType,
      rejectReasonJSON.code,
      rejectReasonJSON.displayOrder,
      rejectReasonJSON.machineTypes.map((machineTypeJSON: any) => IdName.fromJSON(machineTypeJSON)),
      AssertionUtils.isNullOrUndefined(rejectReasonJSON.rejectReasonGroup) ? null : IdName.fromJSON(rejectReasonJSON.rejectReasonGroup),
      rejectReasonJSON.description
    );
  }

  public toJSON(): JSON {
    return {
      name: this._name,
      rgb: {
        red: this._color.rgb.red,
        green: this._color.rgb.green,
        blue: this._color.rgb.blue
      },
      rejectType: this._rejectType,
      code: this._code,
      displayOrder: this._displayOrder,
      machineTypeIds: this._machineTypes.map((machineType: IdName) => machineType.id),
      rejectReasonGroupId: this._group?.id,
      description: this._description
    } as any as JSON;
  }
}
